import { message } from "antd";
import type { UploadFile } from "antd";

/** Fetches a presigned document URL from the API and opens it in a new tab. */
export const openDocumentFromApi = async (request: () => Promise<{ data?: { url?: string } }>) => {
  try {
    const res = await request();
    if (res?.data?.url) {
      window.open(res.data.url, "_blank", "noopener,noreferrer");
    } else {
      message.error("Could not get file link");
    }
  } catch {
    message.error("Failed to fetch file link");
  }
};

/** Opens a file the user just picked (not uploaded yet) in a new tab. */
export const openLocalFile = (file: UploadFile) => {
  if (file.originFileObj) {
    window.open(URL.createObjectURL(file.originFileObj), "_blank", "noopener,noreferrer");
  }
};
